
import { BehaviorSubject } from 'rxjs';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument, DocumentReference } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import Swal from 'sweetalert2'
export interface Usuario {
    id?: string,
    nome: string,
    sobrenome: string,
    perfil: string
}


@Injectable({
    providedIn: 'root'
})

export class AuthenticationService {

    authenticationState = new BehaviorSubject(false);
    currentUser;
    usuario = null;
    loading = true;
    

    constructor(
        public firebaseauth: AngularFireAuth,
        private afs: AngularFirestore
    ) {
        this.checkToken();
    }

    checkToken() {
        this.loading = true;
        return this.firebaseauth.authState.subscribe(
            user => {
                if (user) {
                    this.getUsuario().subscribe(usuario => {
                        if (usuario){
                            this.loading = false;
                            if(usuario.perfil == 'empresa' || usuario.perfil == 'admin'){
                                this.usuario = usuario
                                this.authenticationState.next(true);
                            }
                            else{
                                this.loading = false;
                                this.authenticationState.next(false);
                            }
                        }
                        else{
                            this.loading = false;
                            this.authenticationState.next(false);
                        }
                    });
                }
                else{
                    this.loading = false;
                    this.authenticationState.next(false);
                }
            },
            () => {
                this.loading = false;
                this.authenticationState.next(false);
            }
        );

    }

    async presentAlert(erro) {
        Swal.fire('Atención',erro, 'error');
    }

    getUsuario(): Observable<Usuario>  {
        let _this = this;
        _this.currentUser = _this.firebaseauth.auth.currentUser;
        return _this.getUsuarioById(_this.currentUser.uid);
    }

    getUsuarioById(id: string): Observable<Usuario> {
        let usuarioCollection = this.afs.collection<Usuario>('usuarios');
        return usuarioCollection.doc<Usuario>(id).snapshotChanges().pipe(
            map(a => {
                const data = a.payload.data();
                const id = a.payload.id;
                return { id, ...data };
            })
        );
    }

    login(form) {
        return this.firebaseauth.auth.signInWithEmailAndPassword(form.email, form.password)
            .then(() => {
                ////console.log(this.usuarioService.getUsuario('teste'));
                this.getUsuario().subscribe(usuario => {
                    if (usuario){
                        if(usuario.perfil == 'empresa' || usuario.perfil == 'admin'){
                            this.authenticationState.next(true);
                        }
                        else{
                             this.presentAlert('Área disponible sólo para administradores');
                        }
                    }
                    else{
                        this.presentAlert('Usuario no encontrado');
                    }
                });
            })
            .catch((erro: any) => {
                let message = erro.message;
                if(erro.code == 'auth/wrong-password')
                    message = "Email o contraseña(s) inválido(s)";
                this.presentAlert(message);
            }
        );
    }

    recuperar(email) {
        return this.firebaseauth.auth.sendPasswordResetEmail(email)
            .then(() => {
                return true;
            })
            .catch((erro: any) => {
                console.log(erro);
                let message = erro.message;
                if(erro.code == 'auth/user-not-found')
                    message = "Email no encontrado";
                this.presentAlert(message);
                return false;
            }
        );
    }

    alterarSenha(senha_atual,nova_senha,repita_nova_senha) {
        let _this = this;
        console.log('senha_atual',senha_atual);
        return new Promise(function(resolve, reject) {
            
            if(nova_senha != repita_nova_senha){
                resolve(false);
                _this.presentAlert('As senhas informadas são diferentes');
                return false;
            }

            try{
                _this.firebaseauth.auth.signInWithEmailAndPassword(_this.firebaseauth.auth.currentUser.email,senha_atual).then(() => {
                        try{
                            _this.firebaseauth.auth.currentUser.updatePassword(nova_senha).then(() => {
                                    resolve(true);
                                })
                                .catch((erro: any) => {
                                    resolve(false);
                                    _this.presentAlert(erro.message);
                                }
                            );
                        }
                        catch(erro){
                            resolve(false);
                            _this.presentAlert(erro.message);
                        }

                    })
                    .catch((erro: any) => {
                        resolve(false);
                        _this.presentAlert(erro.message);
                    }
                );
            }
            catch(erro){
                resolve(false);
                _this.presentAlert(erro.message);
            }
        });
    }

    logout() {
        return this.firebaseauth.auth.signOut().then(() => {
            this.usuario = null;
            this.authenticationState.next(false);
        });
    }

    isAuthenticated() {
        return this.authenticationState.value && this.usuario != null;
    }



}